"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var jobRoles = [{
  id: "5e186417e3bb73544084c222",
  value: "Accountant"
}, {
  id: "5e186417e3bb73544084c223",
  value: "Actor / Actress"
}, {
  id: "5e186417e3bb73544084c224",
  value: "Administrative Professional"
}, {
  id: "5e186417e3bb73544084c225",
  value: "Air Traffic Controller"
}, {
  id: "5e186417e3bb73544084c226",
  value: "Analyst"
}, {
  id: "5e186417e3bb73544084c227",
  value: "Architect"
}, {
  id: "5e186417e3bb73544084c228",
  value: "Artist"
}, {
  id: "5e186417e3bb73544084c229",
  value: "Attorney"
}, {
  id: "5e186417e3bb73544084c22a",
  value: "Auditor"
}, {
  id: "5e186417e3bb73544084c22b",
  value: "Banker"
}, {
  id: "5e186417e3bb73544084c22c",
  value: "Barber"
}, {
  id: "5e186417e3bb73544084c22d",
  value: "Bartender"
}, {
  id: "5e186417e3bb73544084c22e",
  value: "Biochemist"
}, {
  id: "5e186417e3bb73544084c22f",
  value: "Builder"
}, {
  id: "5e186417e3bb73544084c230",
  value: "Butcher"
}, {
  id: "5e186417e3bb73544084c231",
  value: "Buyer"
}, {
  id: "5e186417e3bb73544084c232",
  value: "Carpenter"
}, {
  id: "5e186417e3bb73544084c233",
  value: "Catering"
}, {
  id: "5e186417e3bb73544084c234",
  value: "Chef"
}, {
  id: "5e186417e3bb73544084c235",
  value: "Chief Executive / Senior Official"
}, {
  id: "5e186417e3bb73544084c236",
  value: "Civil Service"
}, {
  id: "5e186417e3bb73544084c237",
  value: "Clergy"
}, {
  id: "5e186417e3bb73544084c238",
  value: "Coach"
}, {
  id: "5e186417e3bb73544084c239",
  value: "Creative"
}, {
  id: "5e186417e3bb73544084c23a",
  value: "Customer Service"
}, {
  id: "5e186417e3bb73544084c23b",
  value: "Defense Operations"
}, {
  id: "5e186417e3bb73544084c23c",
  value: "Dentist"
}, {
  id: "5e186417e3bb73544084c23d",
  value: "Designer"
}, {
  id: "5e186417e3bb73544084c23e",
  value: "Developer"
}, {
  id: "5e186417e3bb73544084c23f",
  value: "Dietician"
}, {
  id: "5e186417e3bb73544084c240",
  value: "Director"
}, {
  id: "5e186417e3bb73544084c241",
  value: "Doctor"
}, {
  id: "5e186417e3bb73544084c242",
  value: "Driver"
}, {
  id: "5e186417e3bb73544084c243",
  value: "Editor"
}, {
  id: "5e186417e3bb73544084c244",
  value: "Electrician"
}, {
  id: "5e186417e3bb73544084c245",
  value: "Emergency Services"
}, {
  id: "5e186417e3bb73544084c246",
  value: "Engineer"
}, {
  id: "5e186417e3bb73544084c247",
  value: "Environment and Sustainability"
}, {
  id: "5e186417e3bb73544084c248",
  value: "Farmer"
}, {
  id: "5e186417e3bb73544084c249",
  value: "Filmmaker"
}, {
  id: "5e186417e3bb73544084c24a",
  value: "Fire Services"
}, {
  id: "5e186417e3bb73544084c24b",
  value: "Health Professional"
}, {
  id: "5e186417e3bb73544084c24c",
  value: "IT & Telecommunications"
}, {
  id: "5e186417e3bb73544084c24d",
  value: "Jeweler"
}, {
  id: "5e186417e3bb73544084c24e",
  value: "Journalist"
}, {
  id: "5e186417e3bb73544084c24f",
  value: "Judge"
}, {
  id: "5e186417e3bb73544084c250",
  value: "Lawyer"
}, {
  id: "5e186417e3bb73544084c251",
  value: "Legal"
}, {
  id: "5e186417e3bb73544084c252",
  value: "Librarian"
}, {
  id: "5e186417e3bb73544084c253",
  value: "Maintenance"
}, {
  id: "5e186417e3bb73544084c254",
  value: "Manager"
}, {
  id: "5e186417e3bb73544084c255",
  value: "Mechanic"
}, {
  id: "5e186417e3bb73544084c256",
  value: "Musician"
}, {
  id: "5e186417e3bb73544084c257",
  value: "Military"
}, {
  id: "5e186417e3bb73544084c258",
  value: "Nurse / Midwife"
}, {
  id: "5e186417e3bb73544084c259",
  value: "Optician"
}, {
  id: "5e186417e3bb73544084c25a",
  value: "Other"
}, {
  id: "5e186417e3bb73544084c25b",
  value: "Pharmacist"
}, {
  id: "5e186417e3bb73544084c25c",
  value: "Photographer / Videographer"
}, {
  id: "5e186417e3bb73544084c25d",
  value: "Pilot / Stewad / Stewardess"
}, {
  id: "5e186417e3bb73544084c25e",
  value: "Planning"
}, {
  id: "5e186417e3bb73544084c25f",
  value: "Plumber"
}, {
  id: "5e186417e3bb73544084c260",
  value: "Police Services"
}, {
  id: "5e186417e3bb73544084c261",
  value: "Policy Executive"
}, {
  id: "5e186417e3bb73544084c262",
  value: "Politician"
}, {
  id: "5e186417e3bb73544084c263",
  value: "Programmer"
}, {
  id: "5e186417e3bb73544084c264",
  value: "Project Manager"
}, {
  id: "5e186417e3bb73544084c265",
  value: "Psychologist / psychiatrist"
}, {
  id: "5e186417e3bb73544084c266",
  value: "Public Relations"
}, {
  id: "5e186417e3bb73544084c267",
  value: "Rescue Services"
}, {
  id: "5e186417e3bb73544084c268",
  value: "Researcher"
}, {
  id: "5e186417e3bb73544084c269",
  value: "Salesperson"
}, {
  id: "5e186417e3bb73544084c26a",
  value: "Scientist"
}, {
  id: "5e186417e3bb73544084c26b",
  value: "Social Worker"
}, {
  id: "5e186417e3bb73544084c26c",
  value: "Statistician"
}, {
  id: "5e186417e3bb73544084c26d",
  value: "Supervisor"
}, {
  id: "5e186417e3bb73544084c26e",
  value: "Surgeon"
}, {
  id: "5e186417e3bb73544084c26f",
  value: "Surveyor"
}, {
  id: "5e186417e3bb73544084c270",
  value: "Tax Adviser"
}, {
  id: "5e186417e3bb73544084c271",
  value: "Teacher / Educator"
}, {
  id: "5e186417e3bb73544084c272",
  value: "Technician"
}, {
  id: "5e186417e3bb73544084c273",
  value: "Therapist"
}, {
  id: "5e186417e3bb73544084c274",
  value: "Translator"
}, {
  id: "5e186417e3bb73544084c275",
  value: "Veterinarian"
}, {
  id: "5e186417e3bb73544084c276",
  value: "Writer"
}];
var _default = jobRoles;
exports["default"] = _default;